/*
Aditya        09/26/2022 2700753823  Implement draggable dialog across application
saikrishnapds 10/03/2022 2700753823  Global Field Bugs _350,347,349
akhila 12/23/2022 2700753823 adding style for test title
*/
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import {Tooltip} from '@material-ui/core';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '15px',
  },
  root1: {
    margin: 0,
    padding: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 4,
    color: theme.palette.grey[500],
  },
  dialogTitle: {
    'wordBreak': 'break-all',
    'paddingRight': '30px',
    'fontFamily': 'articulat-cf, sans-serif !important',
    '& span,b': {
      fontFamily: 'articulat-cf, sans-serif !important',
    },
  },
});
const styles1 = (theme) => ({
  root: {
    margin: 0,
    padding: '25px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 4,
    color: theme.palette.grey[500],
  },
});
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
const DialogWithTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4" className={classes.dialogTitle}>{children}</Typography>
      {onClose ? (
        <Tooltip title="Close">
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogWithoutTitle = withStyles(styles1)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '15px 0px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
}))(MuiDialogActions);

const DialogBox = ({
  open,
  dialogClose,
  title,
  button1Text,
  button2Text,
  children,
  maxWidth,
  fullWidth,
  hideFooter = true,
}) => {
  return (
    <Dialog
      onClose={dialogClose}
      aria-labelledby="draggable-dialog-title"
      open={open}
      fullWidth
      maxWidth={maxWidth}
      PaperComponent={PaperComponent}
    >
      {title ? (
        <DialogWithTitle id="draggable-dialog-title" style={{cursor: 'move'}} onClose={dialogClose}>
          {title}
        </DialogWithTitle>
      ) : (
        <DialogWithoutTitle id="draggable-dialog-title" style={{cursor: 'move'}} onClose={dialogClose}>
          {title}
        </DialogWithoutTitle>
      )}
      <DialogContent dividers>{children}</DialogContent>
      {!hideFooter && (
        <DialogActions>
          {button1Text && (
            <Button variant="contained" className="mx-1 " autoFocus onClick={dialogClose}>
              {button1Text}
            </Button>
          )}
          {button2Text && (
            <Button
              variant="contained"
              color="primary"
              className="mx-1 themeing-buttons"
              autoFocus
              onClick={dialogClose}
            >
              {button2Text}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogBox;
